import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomCheckbox',
  props: {
    value: { type: Boolean },
    name: { default: '' },
    label: null,
    checkboxLabel: null,
    tooltip: null,
    enableText: { default: 'Yes' },
    disabledText: { default: 'No' },
    switchType: { type: Boolean },
    disabled: { type: Boolean },
    hideLabel: { type: Boolean },
    extraClasses: null
  },
  emits: ["input", "click-checkbox"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
    (event: 'click-checkbox', payload: { event: MouseEvent; value: boolean }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, name: string, label?: string, checkboxLabel?: string, tooltip?: string, enableText: string, disabledText: string, switchType?: boolean, disabled?: boolean, hideLabel?: boolean, extraClasses?: string };





const computedCheckboxLabel = computed((): string | undefined => {
    if (props.switchType && !props.checkboxLabel?.length) {
        return props.value ? props.enableText : props.disabledText;
    }
    return props.hideLabel ? '' : props.checkboxLabel;
});

const model = computed({
    get: () => props.value,
    set: (value: boolean) => {
        if (value == props.value) return;
        emit('input', value);
    }
});

const handleClick = (event: MouseEvent) => {
    emit('click-checkbox', { event, value: props.value });
};

return { __sfc: true,props, emit, computedCheckboxLabel, model, handleClick }
}

})